import React, { memo } from 'react';

import { Stack } from '@/components/layout';
import { SvgIcon, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';
import BookClassButton from './book-class-button';

type UpcomingWeekEmptyStateProps = {
  onBookClassPress?: () => void;
};

const strings = STRINGS.guardian.home.upcomingWeek;

function UpcomingWeekEmptyState({ onBookClassPress }: UpcomingWeekEmptyStateProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack align="center" justify="center" style={styles.root}>
      <Stack align="center" justify="center" style={styles.iconCircle}>
        <SvgIcon name="IcBook" size={scale(28)} color={guardianColors['6']} />
      </Stack>

      <Text
        numberOfLines={1}
        variant="Font Guardian App/Subtitle/Subtitle 14 Bold"
        style={styles.title}>
        {strings.emptyTitle}
      </Text>
      <Text
        numberOfLines={1}
        variant="Font Guardian App/Subtitle/Subtitle 12 Regular"
        style={styles.subtitle}>
        {strings.emptySubtitle}
      </Text>

      <BookClassButton variant="solid" onPress={onBookClassPress} style={styles.bookClassButton} />
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  root: {
    paddingTop: scale(18),
  },
  iconCircle: {
    width: scale(48),
    height: scale(48),
    borderRadius: scale(24),
    backgroundColor: colors['0'],
    marginBottom: scale(10),
  },
  title: {
    color: guardianColors['6'],
    textAlign: 'center',
  },
  subtitle: {
    color: guardianColors['6'],
    textAlign: 'center',
    marginTop: scale(2),
  },
  bookClassButton: {
    marginTop: scale(10),
  },
}));

export default memo(UpcomingWeekEmptyState);
